import _objectSpread from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
const _excluded = ["label", "tooltip", "className", "icon", "visible"];
var _templateObject;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { createElement } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { basePropTypes, handleProps } from './utils';
import propsToCss from '../utils/propsToCss';
const StyledIconButton = styled(IconButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", "\n"])), props => propsToCss(props));
const IconButtonGy = props => {
  const {
      label,
      tooltip,
      className,
      icon,
      visible
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  if (visible === false) {
    return null;
  }
  const content = /*#__PURE__*/React.createElement(StyledIconButton, _extends({
    "aria-label": label,
    className: className
  }, handleProps(rest)), icon && /*#__PURE__*/createElement(icon), rest.children);
  if (!label && !tooltip || rest.disabled) {
    return content;
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: label || tooltip
  }, content);
};
IconButtonGy.propTypes = _objectSpread(_objectSpread({}, basePropTypes), {}, {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.any,
  label: PropTypes.string
});
export default IconButtonGy;